export default class PricePerTime {
    static fromData(data) {
        if (!data) {
            return;
        }

        let pricePerTime = new PricePerTime();
        pricePerTime.type = data.type;
        pricePerTime.currency = data.currency;
        pricePerTime.net = {
            numerator: data.net.data.numerator,
            denominator: data.net.data.denominator,
        };
        pricePerTime.gross = {
            numerator: data.gross.data.numerator,
            denominator: data.gross.data.denominator,
        };
        pricePerTime.vat = {
            numerator: data.vat.data.numerator,
            denominator: data.vat.data.denominator,
        };
        pricePerTime.netOrGross = data.netOrGross;

        Object.seal(pricePerTime);
        return pricePerTime;
    }

    clone() {
        let pricePerTime = new PricePerTime();
        pricePerTime.type = this.type;
        pricePerTime.currency = this.currency;
        pricePerTime.net = Object.assign({}, this.net);
        pricePerTime.gross = Object.assign({}, this.gross);
        pricePerTime.vat = Object.assign({}, this.vat);
        pricePerTime.netOrGross = this.netOrGross;
        pricePerTime.valid = null == this.valid ? null : this.valid;

        Object.seal(pricePerTime);
        return pricePerTime;
    }

    toData() {
        return {
            netOrGross: this.netOrGross,
            amount: 'net' === this.netOrGross ? this.net : this.gross,
            vat: this.vat,
            currency: this.currency,
            type: this.type,
        }
    }
}
